import { BroadCastChannel } from './enums';

export const createLogoutChannel = () => {
  return new BroadcastChannel(BroadCastChannel.BROADCAST_CHANNEL_NAME);
};
